import { Package } from '@phosphor-icons/react'
import { RatingStars } from './RatingStars'

interface AgentReputationProps {
  completedCount?: number
  avgRating?: number
  reviewCount?: number
  size?: number
  className?: string
}

export function AgentReputation({
  completedCount = 0,
  avgRating = 0,
  reviewCount = 0,
  size = 12,
  className = ''
}: AgentReputationProps) {
  const hasCompleted = completedCount > 0
  const hasRating = reviewCount > 0
  if (!hasCompleted && !hasRating) return null

  return (
    <span className={`inline-flex items-center gap-2 text-xs text-gray-600 flex-wrap ${className}`}>
      {hasCompleted && (
        <span className="inline-flex items-center gap-1">
          <Package size={size} weight="duotone" className="text-emerald-600" />
          <span className="font-medium text-emerald-700">{completedCount}</span>
          <span className="text-gray-500">
            {completedCount === 1 ? 'processo realizado' : 'processos realizados'}
          </span>
        </span>
      )}
      {hasCompleted && hasRating && <span className="text-gray-300">•</span>}
      {hasRating && (
        <RatingStars value={avgRating} size={size} showValue count={reviewCount} />
      )}
    </span>
  )
}
